// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XYhaOm {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.Wu0oBq {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0;
  background: var(--surface-neutral-white, #ffffff);
  border-radius: var(--radius-s, 4px);
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  flex: 1;
}

.Wu0oBq::-webkit-scrollbar {
  display: none;
}

.NPtcPI {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 0;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  z-index: 1;
  padding: 0;
}

.NPtcPI:hover {
  opacity: 0.7;
}

.NPtcPI:focus {
  outline: none;
}

.NPtcPI:disabled {
  cursor: default;
}

.KEIqM6 {
  visibility: hidden;
  pointer-events: none;
}

.iDKVDD {
  margin-right: var(--spacing-0-5);
}

.ZqX_wO {
  margin-left: var(--spacing-0-5);
}

.pbfmvs {
  width: 24px;
  height: 24px;
  color: var(--text-neutral-stronger);
}

.tFyjU8 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 0 0 calc(33.333% - 1px);
  min-width: 0;
  padding: var(--spacing-3, 24px);
  gap: var(--spacing-2, 16px);
  min-height: auto;
  transition: var(--transition-color, background-color 0.2s ease);
  cursor: default;
  box-sizing: border-box;
}

.Cnzxta {
  flex: 1 1 0;
}

.lJtVB4 {
  cursor: default;
  justify-content: space-between;
}

.lJtVB4:hover {
  background-color: transparent;
}

.mdyFPu {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-1-5, 12px);
  width: 100%;
}

.DCl7k8 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  gap: var(--spacing-2);
}

.dcKx6p {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.Blzj4d {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: var(--surface-primary-medium, #d64000);
  border-radius: var(--radius-xl, 16px);
  flex-shrink: 0;
}

.uWFPUA {
  background: var(--surface-primary-medium, #d64000);
}

.PNwVOD {
  background: var(--surface-neutral-subtle, #f2f2f2);
}

.EOaUlD {
  width: 16px;
  height: 16px;
  color: var(--text-neutral-white, #ffffff);
}

.lPReu9 {
  filter: brightness(0) invert(1);
}

.z0DeW_ {
  filter: brightness(0) saturate(100%) invert(43%) sepia(96%) saturate(1352%) hue-rotate(360deg) brightness(102%)
    contrast(97%);
}

.fOc8h3 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0, 2px);
  flex: 1;
}

.fLufkv {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--type-title-md-font-weight, 600);
  font-size: var(--type-title-md-font-size, 16px);
  line-height: 1.424;
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
}

._9537gF {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
}

.IWaT88 {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--type-label-sm-font-weight, 200);
  font-size: var(--type-label-sm-font-size, 12px);
  line-height: var(--type-label-sm-line-height, 2);
  color: var(--text-neutral-silver, #cccccc);
}

.VcpWx9 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
}

.gEun91 {
  width: 6px;
  height: 6px;
  border-radius: var(--radius-xs, 3px);
  flex-shrink: 0;
}

.A67YRd {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0, 2px);
  width: 100%;
}

.VCKqvs {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-1, 8px);
}

.YoWqLd {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--type-label-sm-regular-font-weight, 400);
  font-size: var(--type-label-sm-font-size, 12px);
  line-height: 1.424;
  color: var(--text-neutral-stronger, #666666);
  flex: 1;
}

.S2KJXO {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
  width: 100%;
}

.bR3yOD {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.fXOfRG {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--type-label-sm-regular-font-weight, 400);
  font-size: var(--type-label-sm-font-size, 12px);
  line-height: 1.424;
  color: var(--text-neutral-stronger, #666666);
}

.LE8Yxc {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--type-label-sm-font-weight, 600);
  font-size: var(--type-label-sm-font-size, 12px);
  line-height: 1.424;
  color: var(--text-neutral-dark, #1f1f1f);
}

.lrR5v3 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  padding: var(--spacing-0-5, 4px) 0px;
  background-color: transparent;
  border: none;
  color: var(--text-primary-medium, #d64000);
  font-size: var(--type-label-sm-font-size, 12px);
  font-weight: var(--type-label-sm-font-weight, 600);
  cursor: pointer;
  font-family: var(--font-family-base, 'Source Sans 3');
}

.lrR5v3:hover {
  background-color: var(--surface-primary-subtle, rgba(214, 64, 0, 0.05));
  border-radius: var(--radius-s, 4px);
}

.hlY1jK {
  background-color: var(--surface-neutral-silver, #cccccc);
}

.MvCvvj {
  background-color: var(--status-success, #28a745);
}

.JQvEbD {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--type-label-xs-font-weight, 400);
  font-size: var(--type-label-xs-font-size, 12px);
  line-height: var(--type-label-xs-line-height, 1.424);
  color: var(--text-neutral-silver, #cccccc);
}

.waiixT {
  flex-shrink: 0;
}

.LUXxqH {
  width: 1px;
  height: 150px;
  background-color: var(--stroke-neutral-subtle, #f2f2f2);
  flex-shrink: 0;
  margin: auto 0;
}

.nniGvn {
  display: flex;
  flex: 0 0 calc(33.333%);
  min-width: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .Wu0oBq {
    flex-direction: column;
  }

  .LUXxqH {
    width: 100%;
    height: 1px;
  }

  .tFyjU8 {
    min-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/BenefitCards/BenefitCards.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,MAAM;EACN,iDAAiD;EACjD,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;EAChB,+DAA+D;EAC/D,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,OAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;iBACe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,OAAO;AACT;;AAEA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,+CAA+C;EAC/C,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,+CAA+C;EAC/C,gDAAgD;EAChD,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,0DAA0D;EAC1D,+CAA+C;EAC/C,kBAAkB;EAClB,4CAA4C;EAC5C,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,0DAA0D;EAC1D,+CAA+C;EAC/C,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,+CAA+C;EAC/C,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,YAAY;EACZ,0CAA0C;EAC1C,+CAA+C;EAC/C,kDAAkD;EAClD,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,uEAAuE;EACvE,mCAAmC;AACrC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;EACrD,kDAAkD;EAClD,+CAA+C;EAC/C,oDAAoD;EACpD,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uDAAuD;EACvD,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".carouselWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.container {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 0;\n  background: var(--surface-neutral-white, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  flex: 1;\n}\n\n.container::-webkit-scrollbar {\n  display: none;\n}\n\n.carouselArrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  cursor: pointer;\n  flex-shrink: 0;\n  z-index: 1;\n  padding: 0;\n}\n\n.carouselArrow:hover {\n  opacity: 0.7;\n}\n\n.carouselArrow:focus {\n  outline: none;\n}\n\n.carouselArrow:disabled {\n  cursor: default;\n}\n\n.carouselArrowHidden {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.carouselArrowLeft {\n  margin-right: var(--spacing-0-5);\n}\n\n.carouselArrowRight {\n  margin-left: var(--spacing-0-5);\n}\n\n.arrowIcon {\n  width: 24px;\n  height: 24px;\n  color: var(--text-neutral-stronger);\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  flex: 0 0 calc(33.333% - 1px);\n  min-width: 0;\n  padding: var(--spacing-3, 24px);\n  gap: var(--spacing-2, 16px);\n  min-height: auto;\n  transition: var(--transition-color, background-color 0.2s ease);\n  cursor: default;\n  box-sizing: border-box;\n}\n\n.cardExpanded {\n  flex: 1 1 0;\n}\n\n.cardInactive {\n  cursor: default;\n  justify-content: space-between;\n}\n\n.cardInactive:hover {\n  background-color: transparent;\n}\n\n.cardHeader {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-1-5, 12px);\n  width: 100%;\n}\n\n.cardBody {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  flex: 1;\n  gap: var(--spacing-2);\n}\n\n.cardConfigure {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.iconContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  background: var(--surface-primary-medium, #d64000);\n  border-radius: var(--radius-xl, 16px);\n  flex-shrink: 0;\n}\n\n.iconContainerInactive {\n  background: var(--surface-primary-medium, #d64000);\n}\n\n.iconContainerActive {\n  background: var(--surface-neutral-subtle, #f2f2f2);\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n  color: var(--text-neutral-white, #ffffff);\n}\n\n.iconWhite {\n  filter: brightness(0) invert(1);\n}\n\n.iconOrange {\n  filter: brightness(0) saturate(100%) invert(43%) sepia(96%) saturate(1352%) hue-rotate(360deg) brightness(102%)\n    contrast(97%);\n}\n\n.titleContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0, 2px);\n  flex: 1;\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--type-title-md-font-weight, 600);\n  font-size: var(--type-title-md-font-size, 16px);\n  line-height: 1.424;\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n}\n\n.subtitleContainer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n}\n\n.subtitle {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--type-label-sm-font-weight, 200);\n  font-size: var(--type-label-sm-font-size, 12px);\n  line-height: var(--type-label-sm-line-height, 2);\n  color: var(--text-neutral-silver, #cccccc);\n}\n\n.subtitleWithStatus {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n}\n\n.statusBadge {\n  width: 6px;\n  height: 6px;\n  border-radius: var(--radius-xs, 3px);\n  flex-shrink: 0;\n}\n\n.descriptionContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0, 2px);\n  width: 100%;\n}\n\n.descriptionWithStatus {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-1, 8px);\n}\n\n.description {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--type-label-sm-regular-font-weight, 400);\n  font-size: var(--type-label-sm-font-size, 12px);\n  line-height: 1.424;\n  color: var(--text-neutral-stronger, #666666);\n  flex: 1;\n}\n\n.activeCardInfo {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n  width: 100%;\n}\n\n.activeCardData {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.activeLabel {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--type-label-sm-regular-font-weight, 400);\n  font-size: var(--type-label-sm-font-size, 12px);\n  line-height: 1.424;\n  color: var(--text-neutral-stronger, #666666);\n}\n\n.activeValue {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--type-label-sm-font-weight, 600);\n  font-size: var(--type-label-sm-font-size, 12px);\n  line-height: 1.424;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.buttonConfigure {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  padding: var(--spacing-0-5, 4px) 0px;\n  background-color: transparent;\n  border: none;\n  color: var(--text-primary-medium, #d64000);\n  font-size: var(--type-label-sm-font-size, 12px);\n  font-weight: var(--type-label-sm-font-weight, 600);\n  cursor: pointer;\n  font-family: var(--font-family-base, 'Source Sans 3');\n}\n\n.buttonConfigure:hover {\n  background-color: var(--surface-primary-subtle, rgba(214, 64, 0, 0.05));\n  border-radius: var(--radius-s, 4px);\n}\n\n.statusBadgeInactive {\n  background-color: var(--surface-neutral-silver, #cccccc);\n}\n\n.statusBadgeActive {\n  background-color: var(--status-success, #28a745);\n}\n\n.statusText {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--type-label-xs-font-weight, 400);\n  font-size: var(--type-label-xs-font-size, 12px);\n  line-height: var(--type-label-xs-line-height, 1.424);\n  color: var(--text-neutral-silver, #cccccc);\n}\n\n.progressIndicator {\n  flex-shrink: 0;\n}\n\n.divider {\n  width: 1px;\n  height: 150px;\n  background-color: var(--stroke-neutral-subtle, #f2f2f2);\n  flex-shrink: 0;\n  margin: auto 0;\n}\n\n.cardWrapper {\n  display: flex;\n  flex: 0 0 calc(33.333%);\n  min-width: 0;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .container {\n    flex-direction: column;\n  }\n\n  .divider {\n    width: 100%;\n    height: 1px;\n  }\n\n  .card {\n    min-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselWrapper": `XYhaOm`,
	"container": `Wu0oBq`,
	"carouselArrow": `NPtcPI`,
	"carouselArrowHidden": `KEIqM6`,
	"carouselArrowLeft": `iDKVDD`,
	"carouselArrowRight": `ZqX_wO`,
	"arrowIcon": `pbfmvs`,
	"card": `tFyjU8`,
	"cardExpanded": `Cnzxta`,
	"cardInactive": `lJtVB4`,
	"cardHeader": `mdyFPu`,
	"cardBody": `DCl7k8`,
	"cardConfigure": `dcKx6p`,
	"iconContainer": `Blzj4d`,
	"iconContainerInactive": `uWFPUA`,
	"iconContainerActive": `PNwVOD`,
	"icon": `EOaUlD`,
	"iconWhite": `lPReu9`,
	"iconOrange": `z0DeW_`,
	"titleContainer": `fOc8h3`,
	"title": `fLufkv`,
	"subtitleContainer": `_9537gF`,
	"subtitle": `IWaT88`,
	"subtitleWithStatus": `VcpWx9`,
	"statusBadge": `gEun91`,
	"descriptionContainer": `A67YRd`,
	"descriptionWithStatus": `VCKqvs`,
	"description": `YoWqLd`,
	"activeCardInfo": `S2KJXO`,
	"activeCardData": `bR3yOD`,
	"activeLabel": `fXOfRG`,
	"activeValue": `LE8Yxc`,
	"buttonConfigure": `lrR5v3`,
	"statusBadgeInactive": `hlY1jK`,
	"statusBadgeActive": `MvCvvj`,
	"statusText": `JQvEbD`,
	"progressIndicator": `waiixT`,
	"divider": `LUXxqH`,
	"cardWrapper": `nniGvn`
};
module.exports = ___CSS_LOADER_EXPORT___;
